import { createListSlice, initialState } from '@lumapps/redux/genericListDucks';

export const { reducer, actions } = createListSlice({
    /** Action type prefix. */
    domain: 'event-picker',
});

export { initialState };
